var modules_e182d482 = {"container":"Layout_module_container__376cc73c"};
import "../../../assets/esm/components/Layout/src/Layout~DViGWpTl.css";

export { modules_e182d482 as default };
//# sourceMappingURL=Layout.module.less.js.map
